import React from 'react';
import { Route, IndexRoute } from 'react-router';
import StationHierarchies from './stationHierarchies';
import StationHierarchiesForm from './stationHierarchiesForm';

export default (
  <Route path="station-hierarchies">
    <IndexRoute component={(props) => <StationHierarchies {...props} />} />
    <Route path="novo" component={(props) => <StationHierarchiesForm {...props} />} />
    <Route path=":id/:action" component={(props) => <StationHierarchiesForm {...props} />} />
  </Route>
);
